module.exports = __webpack_public_path__ + "img/pricing-club.e7f38008.png";